import SvgIcon from './SvgIcon/SvgIcon.vue'
import KoalaHeader from './KoalaHeader/KoalaHeader.vue'
import KoalaSide from './KoalaSide/KoalaSide.vue'
import Error403 from './Error/Error403.vue'
import Error404 from './Error/Error404.vue'
import NoData from './NoData/NoData.vue'
import Teleport from './Teleport/Teleport.vue'
import MoreBtnGroup from './MoreBtnGroup/MoreBtnGroup.vue'
import KoalaUpload from './KoalaUpload/KoalaUpload.vue'
import LoginForm from './Login/LoginForm.vue'
import overflowTooltip from '../directives/overflowTooltip'

let components = {
  'SvgIcon': SvgIcon,
  'KoalaHeader': KoalaHeader,
  'KoalaSide': KoalaSide,
  'Error403': Error403,
  'Error404': Error404,
  'NoData': NoData,
  'Teleport': Teleport,
  'MoreBtnGroup': MoreBtnGroup,
  'KoalaUpload': KoalaUpload,
  'LoginForm': LoginForm,
}

const install = Vue => {
  Object.entries(components).forEach(([key, value]) => {
    Vue.component(key, value)
  })
  Vue.use(overflowTooltip)
}

export default {
  install,
  SvgIcon,
  KoalaHeader,
  KoalaSide,
  Error403,
  Error404,
  NoData,
  Teleport,
  MoreBtnGroup,
  KoalaUpload,
  LoginForm,
}
